import { Card, Collapse, Icon } from '@blueprintjs/core'
import React, { ChangeEvent, useEffect, useState } from 'react'
import { Box, CustomButton, CustomDatePicker, CustomSelect } from 'ui-components';
import { ManagementT } from '../../../../utils/constants';
import InputField from '../../../../components/shared/input-field';
import { generateCron, getDateFromCron, getDayFromCron } from '../../../../utils';

const Management = ({
	handleManagementScheduleChange,
	management,
	scheduleOptions,
	handleOnChange,
	handleOpenWebsite
}: {
	handleManagementScheduleChange: (value: string) => void,
	management: ManagementT,
	scheduleOptions: { label: string, value: string }[],
	handleOnChange: (event: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLTextAreaElement>) => void,
	handleOpenWebsite: (url:string)=> void
}) => {
	const [isManagementExpanded, setManagementExpanded] = useState(false);
	const [managementScheduleType,setManagementScheduleType] = useState(getDayFromCron(management?.schedule?.cron || ""));
	const [managementScheduleLabel,setManagementScheduleLabel] = useState(getDayFromCron(management?.schedule?.cron || ""));
	const [selectedDate, setSelectedDate] = useState<Date | null>(getDateFromCron(management?.schedule?.cron || ""));
	useEffect(() => {
		const detectedType = getDayFromCron(management?.schedule?.cron || "");
		setManagementScheduleType(detectedType);
		setManagementScheduleLabel(detectedType);
		setSelectedDate(getDateFromCron(management?.schedule?.cron || ""));
	}, [management?.schedule?.cron]);

	return (
		<>
			<CustomButton
				onClick={() => setManagementExpanded(!isManagementExpanded)}
				icon={isManagementExpanded ? "chevron-down" : "chevron-right"}
			>
				Management
			</CustomButton>
			<Collapse isOpen={isManagementExpanded}>
				<Card className="mt-sm">
					<Box flexDir='row' gap={'small'} items='center' justify='between'>
						<CustomSelect
							title="Schedule"
							flexDir="row"
							isActiveItem={true}
							label={managementScheduleLabel}
							items={scheduleOptions}
							values={[getDayFromCron(management?.schedule?.cron || "")]}
							onSelect={(item) => {setManagementScheduleType(item.value); setManagementScheduleLabel(item.label)}}
						/>
						{managementScheduleType == "Custom" &&
							<InputField
								inputContainerClass='mt-none'
								name={`configDetail.management.schedule.cron`}
								placeholder="enter the custom cron"
								type="text"
								value={management?.schedule?.cron || ""}
								onChange={handleOnChange}
								ptb='5px'
								bradius='5px'
							/>
						}
						{(managementScheduleType != 'Custom' && managementScheduleType != 'Daily') && 
							<CustomDatePicker
								mode="in_date"
								value={selectedDate || ""}
								onValueChange={(dates) => {
									const newDate = dates.length > 0 ? dates[0] : new Date();
									setSelectedDate(newDate);
									const cron = generateCron(managementScheduleType, newDate);
									handleManagementScheduleChange(cron);
								}}
								startDate={new Date()}
							/>
						}

					</Box>
					<InputField
						label="Url"
						name="configDetail.management.url"
						type="text"
						value={management?.url}
						onChange={handleOnChange}
						elem = {<Icon icon="eye-open" size={15} className="ml-xs cursor-pointer" onClick={()=>handleOpenWebsite(management?.url)}/>}
					/>
					<InputField
						label="Response Key"
						name="configDetail.management.response_key"
						type="text"
						value={management?.response_key || ""}
						onChange={handleOnChange}
					/>
					<InputField
						label="Base Regex"
						name="configDetail.management.base_regex"
						type="text"
						value={management?.base_regex || ""}
						onChange={handleOnChange}
					/>
					{Object.entries({...management?.key_and_regex }).map(([key, val]) => (
						<InputField
							key={key}
							label={key
								.split("_")
								.map(word => word.charAt(0).toUpperCase() + word.slice(1))
								.join(" ")}
							name={`configDetail.management.key_and_regex.${key}`}
							type="text"
							value={val}
							onChange={handleOnChange}
						/>
					))}
				</Card>
			</Collapse>
		</>
	)
}

export default Management;